<accredible-base-header-menu [dynamicMenuItems]="dynamicMenuItems"
  [staticMenuItems]="staticMenuItems"
  [user]="user$ | async"
  [redrawObservable]="languageCode$"
  (menuActivated)="onMenuActivated()">
</accredible-base-header-menu>
